import React from 'react';

class RelatedJobBox extends React.Component {
  render() {
    return (
      <div className="col-md-4">
        <div className="box">
          <span className="box-tag">{this.props.data.location}</span>
          <a href={"/single-job/?" + this.props.data._id} className="box-title">
            <span>{this.props.data.title}</span>
          </a>
        </div>
      </div>
    )
  }
}

export default RelatedJobBox;
